import { useId } from "react";
import { Trans } from "react-i18next";
import { Link } from "@sprout/typography";
import { Checkbox, type Option } from "@sprout/checkbox";
import useTranslation from "@hooks/use_translation";
import "./form.scss";

const Acknowlegment = () => {
  const { t } = useTranslation("misc");
  return (
    <Trans
      i18nKey="misc:newUser:acknowledge"
      components={{
        PrivacyPolicy: (
          <Link external href={t("newUser.privacy_policy.url")}>
            {t("newUser.privacy_policy.text")}
          </Link>
        ),
        UserAgreement: (
          <Link external href={t("newUser.user_agreement.url")}>
            {t("newUser.user_agreement.text")}
          </Link>
        ),
      }}
    />
  );
};

interface Props {
  error: string | null;
  onChange: (value: boolean) => void;
  value: boolean;
}

export const TermsOfServiceForm = ({ error, onChange, value }: Props) => {
  const checkboxId = useId();

  const handleSelect = (selectedOptions: Option | Option[]) => {
    if (Array.isArray(selectedOptions)) {
      onChange(selectedOptions.length > 0);
    }
  };

  return (
    <>
      <div className="terms-of-service__checkbox">
        <Checkbox
          isMulti
          required
          id={checkboxId}
          options={[
            {
              value: "1",
              label: <Acknowlegment />,
            },
          ]}
          onSelect={handleSelect}
          error={error}
          values={value ? ["1"] : []}
        />
      </div>
    </>
  );
};
